import { BaseSyntheticEvent, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import * as yup from "yup";
import { AppState } from "../../../../../redux/reducers/rootReducer";
import { startSaveLogo } from "../../../../../redux/actions/correspondenceActions";
import { useStyles } from "../../../../../shared/styles/useStyles";

function useLogoForm() {
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const [file, setFile] = useState<File | null>();
  const [fileName, setFileName] = useState("");
  const [formatError, setFormatError] = useState(false);
  const fileRef = useRef<HTMLInputElement>(null);

  const handleSelectFile = (e: BaseSyntheticEvent) => {
    const file = e.target.files[0] as File;
    if ((file && file.name.indexOf(".png")) !== -1) {
      setFile(file);
      setFormatError(false);
    } else {
      setFormatError(true);
    }
  };

  const initialValues = {
    fileName: file?.name ?? "",
    file: "",
  };

  const validationSchema = yup.object({
    fileName: yup
      .mixed()
      .required(`${intl.formatMessage({ id: "RequiredLogo" })}`),
  });

  const deleteFile = () => {
    if (fileRef.current) {
      fileRef.current.value = "";
      fileRef.current.type = "text";
      fileRef.current.type = "file";
    }
    setFile(null);
  };

  const { contractingOffice } = useSelector(
    (state: AppState) => state.correspondence
  );

  useEffect(() => {
    const name = file?.name ?? "";
    const newName = name ? `${name.slice(0, 25)}...` : "";
    setFileName(newName);
  }, [file]);

  const submit = async () => {
    if (contractingOffice && file) {
      await dispatch(startSaveLogo(contractingOffice, file));
      deleteFile();
    }
  };

  return {
    classes,
    intl,
    fileName,
    fileRef,
    handleSelectFile,
    initialValues,
    deleteFile,
    submit,
    contractingOffice,
    file,
    validationSchema,
    formatError,
  };
}

export default useLogoForm;
